module.exports = __webpack_public_path__ + "/hashedassets-launcher/unsupported_browser.121d33d25b71cecd03ef9c5c0d8d0610.svg";